import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { X, Cookie } from 'lucide-react';
import { Button } from './button';

const COOKIE_CONSENT_KEY = 'reshapers_cookie_consent';

export function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already consented
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      // Small delay before showing the banner
      const timer = setTimeout(() => setIsVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted');
    window.dispatchEvent(new Event('reshapers-consent-accepted'));
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'declined');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 z-50 p-4 sm:p-6 animate-slide-up"
      data-testid="cookie-consent"
    >
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-2xl border border-slate-200 p-4 sm:p-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <div className="flex-shrink-0 hidden sm:block">
            <div className="w-12 h-12 bg-violet-100 rounded-full flex items-center justify-center">
              <Cookie className="w-6 h-6 text-violet-600" />
            </div>
          </div>
          
          <div className="flex-1">
            <h3 className="font-heading font-semibold text-slate-900 mb-1">
              We value your privacy
            </h3>
            <p className="text-sm text-slate-600">
              We use cookies to enhance your browsing experience, serve personalized content, and analyze our traffic. 
              By clicking "Accept All", you consent to our use of cookies. 
              Read our{' '}
              <Link to="/privacy-policy" className="text-violet-600 hover:underline">
                Privacy Policy
              </Link>{' '}
              and{' '}
              <Link to="/cookie-policy" className="text-violet-600 hover:underline">
                Cookie Policy
              </Link>.
            </p>
          </div>
          
          <div className="flex items-center gap-2 w-full sm:w-auto">
            <Button
              variant="outline"
              onClick={handleDecline}
              className="flex-1 sm:flex-none rounded-full text-sm"
              data-testid="cookie-decline-btn"
            >
              Decline
            </Button>
            <Button
              onClick={handleAccept}
              className="flex-1 sm:flex-none bg-violet-600 hover:bg-violet-700 text-white rounded-full text-sm"
              data-testid="cookie-accept-btn"
            >
              Accept All
            </Button>
          </div>
          
          <button
            onClick={handleDecline}
            className="absolute top-3 right-3 sm:hidden text-slate-400 hover:text-slate-600"
            aria-label="Close"
          >
            <X size={20} />
          </button>
        </div>
      </div>
    </div>
  );
}
